module.exports = __webpack_public_path__ + "static/media/scfilter.3c91847b.png";